/* ═══════════════════════════════════════════════════════════════════════
   TAIBI · barra filtri — i select dell'ordinamento restano allineati
   File nostro, non esiste in Dawn. Lo carica `snippets/facets.liquid`.

   PERCHÉ ESISTE. Su telefono l'assetto F2 aggiunge un secondo comando,
   «Ordina», dentro un form suo (`FacetSortForm`). Ma `onSubmitHandler` di
   `facets.js` non manda il form che è stato toccato: ne unisce TRE per id, e
   fra questi c'è `FacetFiltersForm`, che in orizzontale si porta dentro il
   select dell'ordinamento del desktop. Due select con lo stesso `name`
   significano due `sort_by` nella stessa richiesta, e vince l'ultimo.

   Invece di scegliere quale vincerà — che dipende dall'ordine nel DOM, cioè
   dalla cosa più fragile che ci sia — i select portano sempre lo STESSO
   valore: il parametro ripetuto diventa innocuo.

   ⚠️ Il valore si copia SENZA rilanciare l'evento: `facet-filters-form`
   ascolta `input` sul form, e un rimbalzo fra i tre select manderebbe una
   richiesta per ogni copia.
   ⚠️ I select si ricercano a ogni giro: quello dentro il cassetto è un
   `.js-filter` e `facets.js` lo RICREA a ogni filtraggio — un riferimento
   tenuto da parte punterebbe a un elemento che non è più in pagina.
   ═══════════════════════════════════════════════════════════════════════ */

(function () {
  var ID = ['SortByTaibi', 'SortBy', 'SortBy-mobile'];

  function tutti() {
    return ID.map(function (id) {
      return document.getElementById(id);
    }).filter(Boolean);
  }

  function allinea(evento) {
    var sorgente = evento.target;
    if (!sorgente || sorgente.name !== 'sort_by') return;
    if (ID.indexOf(sorgente.id) === -1) return;

    tutti().forEach(function (select) {
      if (select !== sorgente && select.value !== sorgente.value) {
        select.value = sorgente.value;
      }
    });
  }

  /* Un ascoltatore solo, sul documento: i select vanno e vengono, il
     documento no. */
  document.addEventListener('change', allinea);

  /* ═══ Il filtro acceso resta acceso anche dopo il filtraggio ═══
     La classe `taibi-acceso` la scrive anche Liquid, e serve: al primo
     disegno non deve esserci nessun lampo. Ma dopo un filtraggio in AJAX
     `renderFilters` riscrive l'INNERHTML del `.js-filter` e lascia stare
     l'elemento — quindi l'attributo `class` resta quello del caricamento, e
     una pastiglia appena accesa restava spenta. Misurato in vetrina: pallini
     2, pastiglie accese 0.

     ⚠️ La verità sta nel pallino, che Dawn ridisegna insieme al resto: la
     classe si deriva da lui invece di ricontare i filtri qui. Un conto
     ripetuto in due posti è un conto che prima o poi diverge.
     ⚠️ Si osserva `childList`, non `attributes`: la classe che scriviamo qui
     è un attributo, e osservarli farebbe rientrare l'osservatore su se
     stesso a ogni giro. */
  function segnaAccesi() {
    document.querySelectorAll('.taibi-barra .js-filter').forEach(function (filtro) {
      filtro.classList.toggle('taibi-acceso', !!filtro.querySelector('.taibi-pallino'));
    });
  }

  function sorveglia() {
    var barra = document.querySelector('.taibi-barra');
    if (!barra) return;
    new MutationObserver(segnaAccesi).observe(barra, { childList: true, subtree: true });
    segnaAccesi();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sorveglia);
  } else {
    sorveglia();
  }
  document.addEventListener('shopify:section:load', sorveglia);
})();
